module.exports = "<mat-form-field  class=\"w-full mt-2\">\n    <input matInput [(ngModel)]=\"time\" time  ><!--\n    <input matInput id=\"minute\" name=\"minute\" [(ngModel)]=\"minute\" (ngModelChange)=\"ctrl\" >\n    <input matInput id=\"meridiem\" name=\"meridiem\" [(ngModel)]=\"meridiem\" (ngModelChange)=\"ctrl\" >-->\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/time-input/time-input.component.html
// module id = ./src/app/shared/time-input/time-input.component.html
// module chunks = main